import React from 'react';
import { SiteSectionIds } from '../../../../contentful';
import HasLogo from '../../../../assets/airport-logos/has-logo.svg';
import SpaceportLogo from '../../../../assets/airport-logos/spaceport-logo-main.webp';
import IAHLogo from '../../../../assets/airport-logos/iah-logo.webp';
import HOULogo from '../../../../assets/airport-logos/hou-logo.webp';
import EFDLogo from '../../../../assets/airport-logos/efd-logo.webp';

type ILogoInfo = {
	label: string;
	svg?: SVGComponent;
	img?: string;
	className: string;
};

const logoMap: Record<string, ILogoInfo> = {
	[SiteSectionIds.IAH]: {
		img: IAHLogo,
		label: 'George Bush Intercontinental Airport',
		className: 'iah',
	},
	[SiteSectionIds.HOU]: {
		img: HOULogo,
		label: 'William P. Hobby Airport',
		className: 'hou',
	},
	[SiteSectionIds.EFD]: {
		img: EFDLogo,
		label: 'Ellington Airport',
		className: 'efd',
	},
	[SiteSectionIds.Spaceport]: {
		img: SpaceportLogo,
		label: 'Houston Spaceport Logo',
		className: 'spaceport',
	},
	default: { svg: HasLogo, label: 'Houston Airports Logo', className: 'has' },
};

export const getAirportLogo = (siteSectionId?: string) => {
	const logoInfo =
		siteSectionId && logoMap[siteSectionId]
			? logoMap[siteSectionId]
			: logoMap.default;

	if (logoInfo.img) {
		return (
			<img
				src={logoInfo.img}
				alt={logoInfo.label}
				className={logoInfo.className}
			/>
		);
	}

	if (logoInfo.svg) {
		return (
			<logoInfo.svg
				className={logoInfo.className}
				aria-label={logoInfo.label}
			/>
		);
	}

	return null;
};
